import { useEffect } from 'react';
import { Route, Routes, useLocation, useSearchParams } from 'react-router-dom';

import { GuardScope, savePendingRedirect, useAccessGuard } from '@web/app/shared';
import { DefaultLayout2 } from '@web/app/shared/components/default-layout';

import { CodesKeysPage } from '../pages';

export const CodesKeysRoutes = () => {
    const location = useLocation();
    const [searchParams] = useSearchParams();

    // Save callback URL before any redirect happens
    // Use forceOverwrite=true to ensure new state is always saved (fixes state mismatch on retry)
    useEffect(() => {
        const callback = searchParams.get('callback');
        if (callback === 'flow') {
            const fullUrl = location.pathname + location.search;
            savePendingRedirect(fullUrl, true);
        }
    }, [location.pathname, location.search, searchParams]);

    useAccessGuard(GuardScope.Workspace);

    return (
        <Routes>
            <Route element={<DefaultLayout2 />}>
                <Route path="/" element={<CodesKeysPage />} />
                <Route path="/:keyId" element={<CodesKeysPage />} />
            </Route>
        </Routes>
    );
};
